import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'is_the_fac_failing_to_pay_any_worker_at_least_the_legal_minimum'

export const dataPointDefinition = {
  retracedId: 'is_the_fac_failing_to_pay_any_worker_at_least_the_legal_minimum',
  name: 'Is the facility failing to pay any worker AT LEAST the legal minimum wage for any regular hours worked?',
  description:
    'Workers may be paid hourly or by piece/unit or other work output, and can be working under different types of arrangements, e.g., as permanent, casual, temporary, contract workers, probationary workers, trainees, apprentices or interns.\r\r\n\r\r\n"Legal minimum wage" refers to the legally required minimum wage that an employer is required to pay wage earners for the work performed during a given period, which cannot be reduced by collective agreement or an individual contract. This question does not cover wages above the legal minimum wage that are required under employment contracts or a CBA, which are covered separately.\r\r\n\r\r\nConsult applicable legal requirements before answering this question. \r\r\n\r\r\nIf the facility is paying any worker below the legal minimum wage, answer Yes. \r\r\n\r\r\nIf there is no "legal minimum wage", answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wage-2',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7290,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
